import {useDebugValue} from 'react';

import {useTranslations} from './useTranslations';

const defaultSubmitTranslations = {
    checkAvailabilityLabelText: 'Check Availability',
    searchLabelText: 'Search'
};

function useSubmitTranslations(props) {
    const {
        submitTranslations: propsSubmitTranslations
    } = props;

    const {
        translations: submitTranslations
    } = useTranslations(defaultSubmitTranslations, propsSubmitTranslations);

    const result = {
        submitTranslations
    };

    useDebugValue(result);

    return result;
}

export {useSubmitTranslations};
